import React from 'react';
import styled from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const ButtonMore = ({ children, ...props }) => (
  <Button {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill={Colors.nobel}
          fillRule="nonzero"
          d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        />
      </g>
    </svg>
    {children}
  </Button>
);

const Button = styled.button`
  ${Mixins.transition('background-color')};
  border: none;
  background: transparent;
  font-size: 20px;
  color: ${Colors.nobel};
  padding: 0;
  width: 26px;
  height: 24px;
  line-height: 0.8;
  outline: none;
  cursor: pointer;
  border-radius: 50%;
  vertical-align: middle;

  &:hover {
    background-color: ${Colors.ivory};
  }
`;
